import React from 'react';
import { LanguageEnum } from './';

export interface ILocalizedTrademarksStrings {
  // tm list
  Trademarks: string;
  GetStaredBy: string;
  ManageYourTrademarks: string;
  TrademarksBtn: string;
  TrademarksCount: (n: number) => React.ReactNode;
  Search: string;
  Brand: string;
  SaveChanges: string;
  AddNewBrand: string;
  ApplicationDate: string;
  RegistrationDate: string;
  ExpirationDate: string;
  ColumnManager: string;
  ClickToCopyReg: string;
  ClickToCopyApp: string;
  CopiedToClipboard: string;
  Note: string;
  CancelEditing: string;
  CreateColumn: string;
  EditColumn: string;
  CreateNewColumn: string;
  Business: string;
  Reset: string;
  TrademarkNumber: string;
  ['App.']: string;
  ['Reg.']: string;
  RegistrationCertificate: string;
  View: string;
  TrademarkOwner: string;
  RenewRequested: React.ReactNode;

  // tm add new
  HowWouldYou: string;
  UploadRegCertificate: string;
  ProvideRegNum: string;
  ThanksForAdding: (isMultiple: boolean) => string;
  PleaseUpload: string;
  UploadFiles: string;
  WeAskThatAddDashboard: string;
  Back: string;
  AddNewTradeMarks: string;
  Done: string;
  HowManyTm: string;
  Single: string;
  Multiple: string;
  CountPer: (n: number) => string;
  PleaseDownload: string;
  ImportantNote: string;
  SampleExcel: string;
  UploadExcelFile: string;
  Cancel: string;
  AnErrorOccurred: string;
  PleaseProvide: string;
  AppNum: string;
  RegNum: string;
  Or: string;
  EnterAppNum: string;
  EnterRegNum: string;

  // tm details
  TrademarkDetails: string;
  TrademarkInfo: string;
  AdditionalInfo: string;
  TrademarkType: string;
  GoToMyApplication: string;
  TypeOfOwner: string;
  ApplicationLanguageCode: string;
  ClassesAndDesignated: string;
  ApplicantName: string;
  ApplicantAddressCountry: string;
  ApplicantAddress: string;
  DeleteTrademark: string;
  AreYouSureDeleteTrademark: string;
  ThisCannotUndone: string;

  // tm -> brand
  EnterBrandName: string;
  BrandName: string;
  AreYouSureDelete: (item: string) => string;
  HasIpsCannotUndone: (item: string, count: number) => string;
  AddIps: string;
  SelectTrademarks: string;
  EditItem: (item: string) => string;
  ManageIps: string;

  // tm column manager
  Name: string;
  Show: string;
  ColumnManagerTips: string;
  ColumnTipTitle1: string;
  ColumnTipTitle2: string;
  ColumnTipContents1: string;
  ColumnTipContents2: string;
  ColumnTitle: string;
  ThereAreTrademarks: string;
  EnterColumn: string;
  EnterItem: (item: string) => string;
  SelectItem: (item: string) => string;

  // global ip status
  GlobalIpStatus: string;
  IPType: string;
  IPCount: (count: number) => string;
  NotificationCount: (count: number) => string;
  StartProtecting: string;
  Notifications: string;
  YourIPWillExp: string;
  YourIPIsReg: string;
  YourIPIsNowOffice: string;
  YourIPHasExp: string;
  WatchRiskDetected: string;
  Ignore: string;
  RequestRenewal: string;
  YouHaveNoNotification: React.ReactNode;
  RequestRenewalConfirm: string;
  WeAskThatYou: string;
  SetAReminder: string;
  RemindMeAboutThis: string;
  UnprotectedIP: string;
  ViewFullMap: string;
  ExpandPanel: string;
  CollapsePanel: string;
  SeeIPDetails: string;
  Watching: string;
  WatchStatus: string;
  GotIt: string;
}

const LocalizedTrademarksStrings: { [lang: string]: ILocalizedTrademarksStrings } = {
  [LanguageEnum.English]: {
    // tm list
    Trademarks: 'Trademarks',
    GetStaredBy: 'Get started by adding yout trademarks',
    ManageYourTrademarks:
      'Manage your trademarks here for streamlined processes, reduced costs, and accelerated business growth',
    TrademarksBtn: 'Trademarks',
    TrademarksCount: (n: number) => (
      <>
        <strong>{n}</strong> Trademark{n === 1 ? '' : 's'}
      </>
    ),
    Search: 'Search',
    Brand: 'Brand',
    SaveChanges: 'Save changes',
    AddNewBrand: 'Add new brand',
    ApplicationDate: 'Application Date',
    RegistrationDate: 'Registration date',
    ExpirationDate: 'Expiration date',
    ColumnManager: 'Column manager',
    ClickToCopyReg: 'Click to copy registration number',
    ClickToCopyApp: 'Click to copy application number',
    CopiedToClipboard: 'Copied to clipboard!',
    DeleteTrademark: 'Delete trademark',
    Note: 'Note',
    CancelEditing: 'Cancel editing',
    CreateColumn: 'Create column',
    EditColumn: 'Edit column',
    CreateNewColumn: 'Create new column',
    Business: 'Business',
    Reset: 'Reset',
    TrademarkNumber: 'Trademark number',
    ['App.']: 'App.',
    ['Reg.']: 'Reg.',
    RegistrationCertificate: 'Registration certificate',
    View: 'View',
    TrademarkOwner: 'Trademark owner',
    RenewRequested: (
      <>
        Renew
        <br />
        requested
      </>
    ),

    // tm add new
    HowWouldYou: 'How would you like to add your trademarks?',
    UploadRegCertificate: 'Upload registration certificates',
    ProvideRegNum: 'Provide registration numbers or application numbers',
    ThanksForAdding: (isMultiple) => `Thanks for adding your trademark${isMultiple ? 's' : ''}!`,
    PleaseUpload:
      'Please upload your registration certificates. You can upload up to 100 files. Each file can be up to 20MB.',
    UploadFiles: 'Upload files',
    WeAskThatAddDashboard:
      'We ask that you please allow for up to 2 business days to review your request and add your trademarks to the dashboard.',
    Back: 'Back',
    AddNewTradeMarks: 'Add new trademarks',
    Done: 'Done',
    HowManyTm: 'How many trademarks do you want to add?',
    Single: 'Single',
    Multiple: 'Multiple',
    CountPer: (n: number) => `${n.toLocaleString()} of `,
    PleaseDownload:
      'Please download and fill in the same Excel spreadsheet below to import multiple trademarks at once.',
    ImportantNote:
      'Important: At least one registration number or application number must be filled in. All other fields are optional.',
    SampleExcel: 'Sample Excel spreadsheet.xlsx',
    UploadExcelFile: 'Upload Excel file to import data. File can be up to 20MB.',
    Cancel: 'Cancel',
    AnErrorOccurred: 'An error occurred. Please try again.',
    PleaseProvide: 'Please provide either your trademark application number or registration number',
    AppNum: 'Application number',
    RegNum: 'Registration number',
    Or: 'OR',
    EnterAppNum: 'Enter application number',
    EnterRegNum: 'Enter registration number',

    // tm details
    TrademarkDetails: 'Trademark details',
    TrademarkInfo: 'Trademark info',
    AdditionalInfo: 'Additional info',
    TrademarkType: 'Trademark type',
    GoToMyApplication: 'Go to my application',
    TypeOfOwner: 'Type of owner',
    ApplicationLanguageCode: 'Application language code',
    ClassesAndDesignated: 'Classes & designated goods/services',
    ApplicantName: 'Applicant name',
    ApplicantAddressCountry: 'Applicant address country',
    ApplicantAddress: 'Applicant address',
    AreYouSureDeleteTrademark: 'Are you sure you want to delete this trademark?',
    ThisCannotUndone: 'This cannot be undone',

    // tm -> brand
    EnterBrandName: 'Enter brand name',
    BrandName: 'Brand name',
    AreYouSureDelete: (item: string) => `Are you sure you want to delete ${item}?`,
    HasIpsCannotUndone: (item: string, count: number) =>
      `${item} has ${count.toLocaleString()} IP${count === 1 ? '' : 's'}. This cannot be undone.`,
    AddIps: 'Add IPs to the brand',
    SelectTrademarks: 'Select trademarks',
    EditItem: (item: string) => `Edit ${item}`,
    ManageIps: 'Manage IPs of the brand',

    // tm column manager
    Name: 'Name',
    Show: 'Show',
    ColumnManagerTips: 'Column manager tips',
    ColumnTipTitle1: 'Rearrange columns',
    ColumnTipTitle2: 'Create a column',
    ColumnTipContents1:
      'To change column order, select the column you want to move and use the Up and Down arrows. You can also drag-and-drop columns using your mouse.',
    ColumnTipContents2: 'To create a new custom column, click "Create column". You can make up to 5 custom columns."',
    ColumnTitle: 'Title',
    ThereAreTrademarks: 'There are trademarks with this information. This cannot be undone.',
    EnterColumn: 'Enter title',
    EnterItem: (item: string) => `Enter ${item.toLowerCase()}`,
    SelectItem: (item: string) => `Select ${item.toLowerCase()}`,

    // global ip status
    GlobalIpStatus: 'Global IP status',
    IPType: 'IP type',
    IPCount: (count: number) => `${count} IP`,
    NotificationCount: (count: number) => `${count} Notification${count === 1 ? '' : 's'}`,
    StartProtecting: 'Start protecting',
    Notifications: 'Notifications',
    YourIPWillExp: 'Your IP will expire soon',
    YourIPIsReg: 'Your IP is now registered',
    YourIPIsNowOffice: 'Your IP is now in Office Action',
    YourIPHasExp: 'Your IP has expired/canceled',
    WatchRiskDetected: 'Watch: risk detected',
    Ignore: 'Ignore',
    RequestRenewal: 'Request renewal',
    YouHaveNoNotification: (
      <>
        You have no notifications yet.
        <br />
        We will notify you when there are updates about your IP.
      </>
    ),
    RequestRenewalConfirm: 'Request renewal confirmation',
    WeAskThatYou: 'We ask that you please allow for up to 2 business days to review your request',
    SetAReminder: 'Set a reminder',
    RemindMeAboutThis: 'Remind me about this',
    UnprotectedIP: 'Unprotected IP',
    ViewFullMap: 'View full map',
    ExpandPanel: 'Expand panel',
    CollapsePanel: 'Collapse panel',
    SeeIPDetails: 'See IP details',
    Watching: 'Watching',
    WatchStatus: 'Watch status',
    GotIt: 'Got it',
  },
  [LanguageEnum.Korean]: {
    // tm list
    Trademarks: '상표권',
    GetStaredBy: '상표를 추가해보세요',
    ManageYourTrademarks:
      '마크폴리오를 상표를 관리하면 일원화된 프로세스와 비용 절감, 더 빠른 비즈니스 성장을 누려보세요',
    TrademarksBtn: '상표 추가',
    TrademarksCount: (n: number) => (
      <>
        상표 <strong>{n.toLocaleString()}</strong>개
      </>
    ),
    Search: '검색',
    Brand: '브랜드',
    SaveChanges: '변경사항 저장',
    AddNewBrand: '브랜드 추가',
    ApplicationDate: '출원일',
    RegistrationDate: '등록일',
    ExpirationDate: '만료일',
    ColumnManager: '컬럼 관리',
    ClickToCopyReg: '클릭시 등록 번호 복사',
    ClickToCopyApp: '클릭시 어플리케이션 번호 복사',
    CopiedToClipboard: '클립보드에 복사됨',
    DeleteTrademark: '상표 삭제',
    Note: '노트',
    CancelEditing: '수정 취소',
    CreateColumn: '컬럼 추가',
    EditColumn: '컬럼 편빕',
    CreateNewColumn: '컬럼 추가',
    Business: '비즈니스',
    Reset: '재설정',
    TrademarkNumber: '상표 번호',
    ['App.']: '출원',
    ['Reg.']: '등록',
    RegistrationCertificate: '등록증',
    View: '확인',
    TrademarkOwner: '상표권자',
    RenewRequested: <>갱신 요청됨</>,

    // tm add new
    HowWouldYou: '어떻게 상표를 추가하시겠어요?',
    UploadRegCertificate: '등록증 업로드',
    ProvideRegNum: '출원/등록번호 입력',
    ThanksForAdding: () => '상표를 추가해주셔서 감사합니다!',
    PleaseUpload: '등록증을 업로드해주세요. 최대 100개까지 업로드할 수 있으며, 파일은 개당 20MB 이내여야 합니다.',
    UploadFiles: '파일 업로드',
    WeAskThatAddDashboard: '최대 2 영업일 내에 검토 후 대시보드에 상표를 추가해드리겠습니다.',
    Back: '이전',
    AddNewTradeMarks: '상표 추가',
    Done: '완료',
    HowManyTm: '몇 개의 상표를 추가하고 싶으신가요?',
    Single: '한 개',
    Multiple: '여러 개',
    CountPer: (n: number) => `${n} / `,
    PleaseDownload:
      '여러 상표를 한 번에 추가하고 싶으신 경우, 하단의 샘플 파일을 다운로드 후 데이터를 채워 재업로드 해주세요',
    ImportantNote: '중요: 출원번호 혹은 등록번호 중 하나는 입력이 되어야 합니다. 나머지 필드는 선택 항목입니다.',
    SampleExcel: '샘플 파일.xlsx',
    UploadExcelFile: '엑셀파일을 업로드해주세요. 20MB 미만의 파일만 업로드 가능합니다.',
    Cancel: '취소',
    AnErrorOccurred: '오류가 발생했습니다. 다시 시도해주세요.',
    PleaseProvide: '출원번호 또는 등록번호를 입력해주세요',
    AppNum: '출원번호',
    RegNum: '등록번호',
    Or: '또는',
    EnterAppNum: '출원번호 입력',
    EnterRegNum: '등록번호 입력',

    // tm details
    TrademarkDetails: '상표 상세정보',
    TrademarkInfo: '상표 정보',
    AdditionalInfo: '추가 정보',
    TrademarkType: '상표 유형',
    GoToMyApplication: '내 상표 현황 바로가기',
    TypeOfOwner: '출원인 유형',
    ApplicationLanguageCode: '출원서 언어코드',
    ClassesAndDesignated: '상품분류 & 지정상품/서비스',
    ApplicantName: '출원인명',
    ApplicantAddressCountry: '출원인 국가',
    ApplicantAddress: '출원인 주소',
    AreYouSureDeleteTrademark: '이 상표를 삭제하시겠습니까?',
    ThisCannotUndone: '삭제 후에는 복구가 불가합니다',

    // tm -> brand
    EnterBrandName: '브랜드명 입력',
    BrandName: '브랜드명',
    AreYouSureDelete: (item: string) => `${item}을/를 삭제하시겠습니까?`,
    HasIpsCannotUndone: (item: string, count: number) =>
      `${item} 내에 ${count}개의 IP가 있습니다. 삭제 후에는 복구가 불가합니다.`,
    AddIps: '브랜드 내 IP 추가',
    SelectTrademarks: '상표 선택',
    EditItem: (item: string) => `${item} 수정`,
    ManageIps: '브랜드 내 IP 관리',

    // tm column manager
    Name: '이름',
    Show: '표시 여부',
    ColumnManagerTips: '컬럼 관리 팁',
    ColumnTipTitle1: '컬럼 순서 조정',
    ColumnTipTitle2: '신규 컬럼 추가',
    ColumnTipContents1:
      '조정하고 싶은 컬럼을 클릭하고, 위아래 화살표를 이용해 컬럼 순서를 조정하세요. 마우스를 통해 컬럼을 원하는 위치로 드래그앤드롭 하셔도 됩니다.',
    ColumnTipContents2:
      '"컬럼 추가" 버튼을 눌러 새로운 컬럼을 추가하실 수 있습니다. 커스텀 컬럼은 최대 5개까지 추가 가능합니다.',
    ColumnTitle: '컬럼명',
    ThereAreTrademarks: '해당 정보를 가진 상표가 있습니다. 삭제 후에는 복구가 불가합니다.',
    EnterColumn: '컬럼명 입력',
    EnterItem: (item: string) => `${item} 입력`,
    SelectItem: (item: string) => `${item.toLowerCase()} 선택`,

    // global ip status
    GlobalIpStatus: '글로벌 IP 현황',
    IPType: 'IP 유형',
    IPCount: (count: number) => `IP ${count}개`,
    NotificationCount: (count: number) => `알림 ${count}개`,
    StartProtecting: '권리 등록하기',
    Notifications: '알림',
    YourIPWillExp: 'IP가 곧 만료됩니다',
    YourIPIsReg: 'IP가 등록되었습니다',
    YourIPIsNowOffice: 'IP가 중간거절되었습니다',
    YourIPHasExp: 'IP가 만료/취소되었습니다',
    WatchRiskDetected: '모니터링: 위험이 감지되었습니다',
    Ignore: '알림 끄기',
    RequestRenewal: '연장 신청',
    YouHaveNoNotification: (
      <>
        알림이 없습니다.
        <br />
        IP 관련 업데이트가 있을 때 알려드리겠습니다.
      </>
    ),
    RequestRenewalConfirm: '연장 신청이 완료되었습니다',
    WeAskThatYou: '2 영업일 내 리뷰 후 연락드리겠습니다',
    SetAReminder: '리마인더 설정',
    RemindMeAboutThis: '언제 다시 알려드릴까요?',
    UnprotectedIP: '보호되지 않은 IP',
    ViewFullMap: '전체보기',
    ExpandPanel: '패널열기',
    CollapsePanel: '패널접기',
    SeeIPDetails: 'IP 상세보기',
    Watching: '모니터링중',
    WatchStatus: '모니터링 상태',
    GotIt: '확인',
  },
};

export default LocalizedTrademarksStrings;
